import { Container, Text } from "@chakra-ui/react";
import { getTokenInfo } from "../../config/tokens";

export function AssetDescription({ chainId, token }) {
  const description = getTokenInfo(chainId, token)?.description;

  return (
    token && (
      <Container bg="#bee3f8" py="1em" borderRadius="0.25em">
        <Text>
          🎯&nbsp;{token}:&nbsp;
          {description}
        </Text>
      </Container>
    )
  );
}
